import React from 'react';
import './Finance.scss';
import MolLink from '../../Basepage/parts/Menu/MolLink';

interface UmsatzeProp {
  data: any;
  apiBase: string;
}
interface UmsatzeState {}

export default class Umsatze extends React.Component<
  UmsatzeProp,
  UmsatzeState
> {
  constructor(prop) {
    super(prop);
  }

  render(): React.ReactNode {
    let yearKeys = Object.keys(this.props.data.yearData ?? {}).reverse();

    return (
      <div id="umsatze">
        <h3>Umsatzeübersicht</h3>
        <br />
        <br />
        Umsätze nach Jahren
        <table>
          <thead>
            <tr>
              <th>Jahr</th>
              <th>Umsatz netto</th>
              <th>Umsatzsteuer</th>
              <th>Umsatz brutto</th>
            </tr>
          </thead>
          <tbody>
            {yearKeys.map((yearKey, yearIndex) => {
              let yearData = this.props.data.yearData[yearKey];
              let className = 'row ' + (yearIndex % 2 == 0 ? 'mod2' : '');
              return (
                <tr key={'finance_year_' + yearKey} className={className}>
                  <td>{yearKey}</td>
                  <td>
                    {new Intl.NumberFormat('de-DE', {
                      style: 'currency',
                      currency: 'EUR',
                    }).format(yearData.netto)}
                  </td>
                  <td>
                    {new Intl.NumberFormat('de-DE', {
                      style: 'currency',
                      currency: 'EUR',
                    }).format(yearData.tax)}
                  </td>
                  <td>
                    {new Intl.NumberFormat('de-DE', {
                      style: 'currency',
                      currency: 'EUR',
                    }).format(yearData.brutto)}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
        <br />
      </div>
    );
  }
}
